import { Metric } from '../../../../dashboard-config/dashboard-config.model';
import {
  expandProductCatalog,
  ProductCatalogEntry,
} from '../../../_shared/dashboard-definition.model';
import { createDashboardIndexRankingDevelopmentDefinition } from './create-dashboard-index-ranking-development-definition';
import {
  IndexDevelopmentMetricProfile,
  indexDevelopmentCompaniesRevenueProfile,
  indexDevelopmentEconomicParticipantProfile,
  indexDevelopmentEmployedProfile,
  indexDevelopmentGrossValueAddedProfile,
} from './index-ranking-development-metric.profile';
import { DashboardIndexRankingDevelopmentShell } from './dashboard-index-ranking-development-shell.profile';
import { DashboardIndexRankingDevelopmentDefinition } from './dashboard-index-ranking-development.definition';

/**
 * Product catalog for index ranking-development dashboards.
 * Identity is derived in {@link createDashboardIndexRankingDevelopmentDefinition}.
 */

// Pending dataset: CompaniesCount index.
type IndexRankingDevelopmentMetric = Exclude<
  Metric,
  Metric.Tourism | Metric.SelfEmployed | Metric.CompaniesCount
>;

const INDEX_RANKING_DEVELOPMENT_SHELLS: readonly DashboardIndexRankingDevelopmentShell[] = ['subMarkets', 'wzClasses', 'districtSubMarkets'];

export const INDEX_RANKING_DEVELOPMENT_PRODUCT_CATALOG: Record<
  IndexRankingDevelopmentMetric,
  ProductCatalogEntry<
    IndexDevelopmentMetricProfile,
    DashboardIndexRankingDevelopmentShell
  >
> = {
  [Metric.CompaniesRevenue]: {
    metric: indexDevelopmentCompaniesRevenueProfile,
    shells: ['subMarkets', 'wzClasses', 'districtSubMarkets'],
  },
  // Pending dataset: districtSubMarkets.
  [Metric.GrossValueAdded]: {
    metric: indexDevelopmentGrossValueAddedProfile,
    shells: ['subMarkets', 'wzClasses'],
  },
  // Pending dataset: districtSubMarkets.
  [Metric.EconomicParticipant]: {
    metric: indexDevelopmentEconomicParticipantProfile,
    shells: ['subMarkets', 'wzClasses'],
  },
  [Metric.Employed]: {
    metric: indexDevelopmentEmployedProfile,
    shells: ['subMarkets', 'wzClasses', 'districtSubMarkets'],
  },
};

/** All index ranking-development product definitions. */
export const INDEX_RANKING_DEVELOPMENT_DEFINITIONS: DashboardIndexRankingDevelopmentDefinition[] =
  expandProductCatalog(
    Object.values(INDEX_RANKING_DEVELOPMENT_PRODUCT_CATALOG),
    createDashboardIndexRankingDevelopmentDefinition,
  );
